import { FieldSpec } from 'lib/rich'
import { UnitShorthand } from 'types/unit-shorthand'
import { unit_spec } from './common'

export namespace HolderShaftSegment {
  export const Version = 1

  export type Data = {
    height: number
    upperDiameter: number
    lowerDiameter: number
    aboveGaugeLine: boolean
  }

  export const Spec: readonly (FieldSpec & { id: keyof Data })[] = [
    {
      id: 'height',
      title: 'Height',
      kind: 'length',
      defaultValueMM: 2,
      defaultValueIN: 0.1,
      gte: 0,
      required: true,
    },
    {
      id: 'upperDiameter',
      title: 'Upper Diameter',
      inlineTitle: '⌀ Upper',
      kind: 'length',
      defaultValueMM: 6,
      defaultValueIN: 0.25,
      gt: 0,
      required: true,
    },
    {
      id: 'lowerDiameter',
      title: 'Lower Diameter',
      inlineTitle: '⌀ Lower',
      kind: 'length',
      defaultValueMM: 6,
      defaultValueIN: 0.25,
      gt: 0,
      required: true,
    },
    /*
    {
      id: 'aboveGaugeLine',
      title: 'Above Gauge Line',
      kind: 'boolean',
      defaultValue: false,
      required: true,
      hidden: true,
    },
    */
  ] as const
}

export namespace ToolHolder {
  export const Version = 1

  export type Data = {
    unit: UnitShorthand
    guid?: string
    description?: string
    vendor?: string
    productId?: string
    productLink?: string
    segments: HolderShaftSegment.Data[]
    gaugeLength?: number
  }

  export const Spec: readonly (FieldSpec & { id: keyof Data | undefined })[] = [
    { id: 'unit', ...unit_spec, hidden: true },

    { id: 'guid', title: 'GUID', kind: 'guid', hidden: true },

    // Use name istead of description
    /*
    {
      id: 'description',
      title: 'Description',
      kind: 'text',
      defaultValue: '',
      //noLabel: true,
    },
    */

    //{ id: undefined, kind: 'group', title: 'Vendor' },
    {
      id: 'vendor',
      title: 'Vendor',
      kind: 'text',
      defaultValue: '',
      //noLabel: true,
    },
    { id: 'productId', title: 'Product ID', kind: 'text', defaultValue: '' },
    {
      id: 'productLink',
      title: 'Product Link',
      kind: 'text',
      defaultValue: '',
    },

    { id: undefined, kind: 'group', title: 'Geometry' },
    {
      id: undefined,
      kind: 'placeholder',
      title: 'Preview',
      componentId: 'HolderPreview',
    },
    {
      id: 'segments',
      title: 'Segments',
      kind: 'array',
      showAsTable: true,
      noLabel: true,
      itemSpecs: HolderShaftSegment.Spec,
      defaultValueMM: [
        {
          height: 10,
          upperDiameter: 30,
          lowerDiameter: 20,
          aboveGaugeLine: true,
        },
        {
          height: 4,
          upperDiameter: 20,
          lowerDiameter: 20,
          aboveGaugeLine: true,
        },
      ],
    },

    {
      id: 'gaugeLength',
      title: 'Gauge Length',
      kind: 'length',
      compute: (data) => {
        const segments = data.segments || []
        return segments.length > 0 ? segments[0].height : undefined
      },
    },
  ] as const
}
